import { axiosInstance } from "../axiosInstance";

const getMatchList = ({ page,
    per_page = 10,
    delay = 1,
    search }) => axiosInstance.get(`_agency/confirmed-matches`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const getMatchCreateList = ({ page,
    per_page = 10,
    delay = 1,
    search }) => axiosInstance.get(`_agency/matches`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const getThemes = ({
    search }) => axiosInstance.get(`_agency/themes`, {
        params: {
            search
        }
    }).then(res => res?.data)

const getLevels = ({
    search }) => axiosInstance.get(`_agency/levels`, {
        params: {
            search
        }
    }).then(res => res?.data)

const getMatchStyle = ({
    search }) => axiosInstance.get(`_agency/match-styles`, {
        params: {
            search
        }
    }).then(res => res?.data)

const getUsers = ({
    search }) => axiosInstance.get(`_agency/match/users`, {
        params: {
            search
        }
    }).then(res => res?.data)

const getAllUsers = ({ page,
    per_page = 100,
    search,
    ...params
}) => axiosInstance.get(`_agency/match/all_users`, {
    params: {
        page,
        per_page,
        // delay,
        search,
        ...params
    }
}).then(res => res?.data)


const getAgencies = ({ page,
    per_page = 100,
    delay = 1,
    search }) => axiosInstance.get(`_agency/match/agencies`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const addMatch = (data) => axiosInstance.post(`_agency/match/create`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
export { getMatchList, getMatchCreateList, getThemes, getLevels, getMatchStyle, getUsers, addMatch, getAllUsers, getAgencies };
